export class RateManager
{
	rateId: number;
	createDate: Date;
	lastUpdate: Date;
	effectiveDate: Date;
	descriptionOps: string;
	descriptionOwner: string;
	descriptionGuest: string;
	rateType: string;
	defaultRate: number;
	discountRate: number;
	effectiveRate: number;
	numOfDaysForwardToAnalyze: number;
	numOfDaysBackwardToAnalyze: number;
	discountMaxPercent: number;
	discountLookForwardDays: number;
	discountHeadlineSpecialsLookForwardDays: number;
	discountHeadlineSpecialsMinNightsToAnalyze: number;
	minStayExpected: number;
	avgStayFor: number;
	shortTermGapMultiplier: number;
	shortTermGapPenaltyPercent: number;
	shortTermGapMinNightsReqRev: number;
	longTermGapMultiplier: number;
	longTermGapPenaltyPercent: number;
	connectingFrontOrBackMultiplier: number;
	connectingFrontAndBackMultiplier: number;
	lengthOfStayDiscountFactorOffset: number;
	adjustmentPercent: number;
	adjustmentAmount: number;
	adjustmentNights: number;
	NumNightsStay: number;
	numNightsAvailableInPeriod: number;
	numNightsActuallyEmpty: number;
	numNightsToNextCheckin: number;
	numNightsFromPreviousCheckout: number;
	numNightsLikelyEmpty: number;
	numNightsLikelyEmptyFromPreviousCheckout: number;
	numNightsLikelyEmptyToNextCheckin: number;
	guestSuggestionText: string;
	reservationQuality: number;
	reservationQualityName: number;
	opsNotes: string;
	debug: string;
}
